import { createValidationErrors } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { SavedReportValidation } from 'app/area/shared/saved-reports/types-store';
import { DashboardAdminTranslation, minWidth } from '../constants';
import { SavedReportDashboard } from './types-store';

export const validateSavedReport = (
  savedReport: SavedReportDashboard,
  currentSavedReportId: number,
  allSavedReportIs: number[],
  translation: DashboardAdminTranslation
): SavedReportValidation<SavedReportDashboard> => {

  const savedReportId = savedReport?.code?.value;

  return {
    ...(!isDefinedIncludingZero(savedReportId)
      ? {
        code: createValidationErrors([translation?.must_be_filled_out])
      }
      : (savedReportId !== currentSavedReportId && allSavedReportIs?.includes(savedReportId) && {
        code: createValidationErrors([translation?.saved_id_validation])
      })),
    ...((savedReport?.minWidth ?? 0) < minWidth && {
      minWidth: createValidationErrors([replaceTemplateString(translation?.min_width_validation, minWidth)])
    })
  };
};
